import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { StripeConfigurationCard } from './components/stripe-configuration-card'
import { StripeAccountDetailsCard } from './components/stripe-account-details-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface StripeProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const StripeProcessorDetailsPage = ({ processor }: StripeProcessorDetailsPageProps) => {

    return (
        <>
            <ProcessorHeader
                type="stripe"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <StripeConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
            <StripeAccountDetailsCard processor={processor} />
        </>
    )
}

